<template>
  <router-link to="/ssv" class="ssv has-background-primary is-block is-clipped is-relative">
    <div class="columns  is-multiline is-vcentered" v-if="$whitelabel.short.toLowerCase() === 'adac'">
      <div
        class="column is-8-tablet is-offset-2-tablet is-6-widescreen is-6-desktop is-offset-0-desktop ssv__content ssv__content--adac mt-3">
        <div class="has-text-centered-touch ssv__text--adac">
          <div
            class="title is-inline-block is-size-3-mobile is-size-2-tablet is-size-1-widescreen has-text-weight-bold has-text-black">
            <p
              class="has-background-secondary is-size-5 is-size-3-tablet  is-inline-block has-text-weight-bold has-text-white pr-1 pl-1 mb-3">
              ADAC Hotelgutschein
            </p>

            <p class="is-size-3-desktop is-size-2-widescreen is-size-1-fullhd"><span
                class="is-inline-block-tablet is-block-mobile has-text-black ">Sommer-Schluss-Verkauf</span><span
                class="is-inline-block is-size-4-mobile">vom 30.08. - 13.09.2021</span></p>
          </div>
          <!-- <p class=" has-text-black is-size-6 is-size-5-tablet has-text-weight-bold">vom 30.08. - 13.09.2021</p> -->

          <b-button tag="router-link" to="/ssv" type="is-light" size="is-medium" class="mt-5 is-hidden-touch"
            icon-left="angle-double-right">
            Zu den SSV-Deals
          </b-button>
        </div>
      </div>
      <div class="column is-12-tablet is-6-widescreen is-6-desktop ssv__img--adac">
        <p class=" has-text-centered has-text-right-desktop">
          <img fetchpriority="high"
            :src="`https://assets.urlaubsgutschein.kaufen/i/resize?width=800&quality=50&type=auto&interlace=true&file=whitelabel/adac/campaigns/ssv.png`"
            alt="SSV" width="781" height="326" />
        </p>
      </div>
    </div>
  </router-link>
</template>

<script>
export default {
  name: 'SummerSale',

  props: {},
  methods: {},
}
</script>

<style scoped lang="scss">
.ssv {
  .title {
    margin-bottom: 0.75rem;
  }
}

.ssv__content {
  @media screen and (min-width: 769px) {
    margin-top: 3rem;
  }
}

@media screen and (min-width: 1024px) {
  .ssv__text--adac {
    margin-top: 1rem;
    margin-bottom: 2rem;
    margin-left: 3rem;
    margin-right: 0;
  }

  .ssv__img--adac {
    margin-top: 1rem;
    margin-bottom: 1rem;
  }
}

@media screen and (min-width: 1216px) {
  .ssv__img--adac {
    margin-right: 3rem;
    margin-left: -4rem;
  }
}
</style>
